<section fxFlex fxLayout="column" fxLayoutGap="20px">
  <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign.xs="start center" fxLayoutGap="20px">
    <p class="issue-description">
      We regret to inform you that there was a technical issue that occurred around the time you
      submitted your application, which resulted in an inability to complete your online banking
      credentials. Please try again.
    </p>
  </div>
  <div fxFlex fxLayoutAlign="center center">
    <button mat-flat-button class="primary-btn-action" color="primary" (click)="tryAgain()">CREATE LOGIN</button>
  </div>
</section>
